import { AritoIcon } from '@/components/custom/arito/icon';
import { NavMenu } from '../types';

export const heThongMenu: NavMenu = {
  title: 'Hệ thống',
  items: [
    {
      title: 'Người sử dụng',
      icon: <AritoIcon icon={828} />,
      group: 0,
      items: [
        {
          title: 'Khai báo người sử dụng và phân quyền hệ thống',
          icon: <AritoIcon icon={826} />,
          href: '/he-thong/nguoi-su-dung/khai-bao-nguoi-su-dung-va-phan-quyen'
        },
        {
          title: 'Khai báo nhóm người sử dụng và phân quyền hệ thống',
          icon: <AritoIcon icon={380} />,
          href: '/he-thong/nguoi-su-dung/khai-bao-nhom-nguoi-su-dung-va-phan-quyen'
        }
      ]
    },
    {
      title: 'Phân quyền',
      items: [
        {
          title: 'Danh sách đơn vị, chi nhánh',
          href: '/he-thong/phan-quyen/danh-sach-don-vi-chi-nhanh',
          icon: <AritoIcon icon={137} />
        },
        {
          title: 'Phân quyền truy cập theo đơn vị',
          href: '/he-thong/phan-quyen/phan-quyen-truy-cap-theo-don-vi'
        },
        {
          title: 'Chức năng tổng quát',
          icon: <AritoIcon icon={381} />,
          href: '/he-thong/phan-quyen/chuc-nang-tong-quat'
        }
      ]
    },
    {
      title: 'Chứng từ',
      icon: <AritoIcon icon={57} />,
      items: [
        {
          title: 'Thông tin chứng từ',
          icon: <AritoIcon icon={236} />,
          href: '/he-thong/chung-tu/thong-tin-chung-tu'
        },
        {
          title: 'Cấu trúc quyền số chứng từ',
          icon: <AritoIcon icon={551} />,
          href: '/he-thong/chung-tu/cau-truc-quyen-so-chung-tu'
        },
        {
          title: 'Giới hạn quyền truy cập cho TRẠNG THÁI chứng từ',
          icon: <AritoIcon icon={546} />,
          href: '/he-thong/chung-tu/gioi-han-quyen-truy-cap-cho-trang-thai-chung-tu'
        }
      ]
    },
    {
      title: 'Lịch sử',
      icon: <AritoIcon icon={558} />,
      group: 0,
      items: [
        {
          title: 'Nhật ký hệ thống',
          icon: <AritoIcon icon={580} />,
          href: '/he-thong/lich-su/nhat-ky-he-thong'
        },
        {
          title: 'Chứng từ bị xóa',
          icon: <AritoIcon icon={8} />,
          href: '/he-thong/lich-su/chung-tu-bi-xoa'
        }
      ]
    },
    {
      title: 'Kết nối HĐĐT',
      icon: <AritoIcon icon={8} />,
      items: [
        {
          title: 'Danh mục quyển hóa đơn điện tử',
          icon: <AritoIcon icon={8} />,
          href: '/he-thong/ket-noi-hddt/danh-muc-quyen-hoa-don-dien-tu'
        },
        {
          title: 'Danh mục tài khoản hóa đơn điện tử',
          icon: <AritoIcon icon={8} />,
          href: '/he-thong/ket-noi-hddt/danh-muc-tai-khoan-hoa-don-dien-tu'
        },
        {
          title: 'Khai báo sử dụng tài khoản hóa đơn điện tử',
          icon: <AritoIcon icon={8} />,
          href: '/he-thong/ket-noi-hddt/khai-bao-tai-khoan-su-dung-hoa-don-dien-tu'
        }
      ]
    }
  ]
};
